import type * as lazyIndex from "./lazyIndex";
import { options_messageorganization_searchterms } from "owa-search-locstrings/lib/strings/options_messageorganization_searchterms.locstring.json";
import { options_messageorganization_title } from "owa-locstrings/lib/strings/options_messageorganization_title.locstring.json";
import type { LazyOption } from "owa-options-core";
import { createLazyOption } from "owa-options-core";
import { LazyModule, LazyAction } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import("./lazyIndex"), {
    name: "ConversationsV2Option",
});
const ConversationsV2Option: LazyOption = createLazyOption({
    key: "conversationsV2",
    titleStringKey: options_messageorganization_title,
    searchTermsStringKey: options_messageorganization_searchterms,
    allowedOptionKeys: ["Conversations"],
    copilotSettingKey: "messagelist",
}, lazyModule, m => m.fullOption);
export default ConversationsV2Option;

export const lazySaveConversationsV2OptionQuick: LazyAction<typeof lazyIndex.saveConversationsOptionQuick, typeof lazyModule> = new LazyAction(lazyModule, m => m.saveConversationsOptionQuick);
